import React from 'react';
// COMPONENTS
import Lottie from 'react-lottie';
import * as animationData from 'lib/media/empty_box.json';
import Row from 'components/common/Row';
import Body from 'components/text/Body';
import Title from 'components/text/Title';
import AlreadyCreated from './AlreadyCreated';
import { Link } from 'react-router-dom';
import InvoiceList from './InvoiceList';
import ChoiceSelect from './ChoiceSelect';

const DontCreate = () => (
  <div style={{ padding: 25, background: '#efefef' }}>
    <Title>We will not create invoices automatically for this contract.</Title>
  </div>
);

const NoInvoicesToCreate = () => (
  <Row type="flex" align="middle" justify="center" style={{ height: 300 }}>
    <div style={{ textAlign: 'center' }}>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          height: 200,
          animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
          },
        }}
        width={200}
        height={200}
      />
    <div>
      <h1>You have no invoices to create.</h1>
      <h4>You can go ahead and create your contract.</h4>
    </div>
    </div>
  </Row>
);

const NeedsPaymentIntegration = () => (
  <div style={{ padding: 25, background: '#efefef' }}>
    <h2>You Still Need to Connect a Payment Service!</h2>
    <h3>
      HeyNed Contracts & Payments are integrated to simplify your business. Send invoices via HeyNed. Get paid via
      Stripe or Paypal. Automated payments help you save time & avoid late payments.
    </h3>
    <Link to="/app/studio" style={{ marginTop: 15, display: 'block', fontSize: 16 }} target="_blank">
      GO TO MY STUDIO INTEGRATIONS
    </Link>
  </div>
);

const Header = () => (
  <div style={{ padding: 25, background: '#efefef' }}>
    <Title>HeyNed Contracts & Payments are integrated to simplify your business.</Title>
    <Body>
      Send invoices via HeyNed. Get paid via Stripe or Paypal. Automated payments help you save time & avoid late
      payments.
    </Body>
  </div>
);

class InvoicesInfo extends React.Component {
  state = {
    createInvoices: 'create',
    autoSend: 'dont-auto-send',
  };

  onAutoSendChange = autoSend => {
    this.setState({ autoSend });
  };

  onChoiceChange = createInvoices => {
    const { contract } = this.props;
    const {
      depositDueDate, depositAmount, finalPaymentDueDate, finalPaymentAmount,
    } = contract;

    let invoices = {
      invoice1: { depositAmount, depositDueDate },
      invoice2: { finalPaymentAmount, finalPaymentDueDate },
    };

    let fieldChange = {
      createInvoices,
      invoices,
    };
    this.props.onChange(fieldChange);
  };

  renderTop = () => {
    const { contract, currencySymbol } = this.props;
    const {
      depositDueDate, depositAmount, finalPaymentDueDate, finalPaymentAmount,
    } = contract;

    if (contract.createInvoices === 'dont-create') {
      return (
        <div>
          <Header />
          <DontCreate />
        </div>
      );
    }

    return (
      <div>
        <Header />
        <InvoiceList
          depositAmount={depositAmount}
          currencySymbol={currencySymbol}
          finalPaymentAmount={finalPaymentAmount}
          finalPaymentDueDate={finalPaymentDueDate}
          depositDueDate={depositDueDate}
        />
      </div>
    );
  };

  render() {
    const { contract, currencySymbol, currentUser } = this.props;

    const { depositAmount, finalPaymentAmount } = contract;
    // const stripeExists = contract && contract.organization && contract.organization.stripeUserIdExists;

    if (!currentUser.paypalSet && !currentUser.stripeSet) {
      return <NeedsPaymentIntegration contract={contract} />;
    }

    // // if invoicesCreated = true, then this person may have already created invoices for this contract.
    if (contract.invoicesCreated) {
      return <AlreadyCreated currencySymbol={currencySymbol} contract={contract} />;
    }

    if (!depositAmount && !finalPaymentAmount) {
      return <NoInvoicesToCreate />;
    }

    return (
      <div style={{ padding: 10 }}>
        <div
          style={{
            border: '2px solid #efefef',
            width: 750,
            maxWidth: '100%',
            margin: 'auto',
          }}
        >
          {this.renderTop()}
        </div>
        <ChoiceSelect
          autoSend={this.state.autoSend}
          onAutoSendChange={this.onAutoSendChange}
          createInvoices={contract.createInvoices}
          onChoiceChange={this.onChoiceChange}
        />
      </div>
    );

    return (
      <div>
        <Header />
        {contract.createInvoices === 'dont-create' && <DontCreate />}
        <InvoiceList />
      </div>
    );
  }
}

export default InvoicesInfo;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/InvoicesInfo/index.js